/**
 * User Saved Search  Actions
 */
export const USER_SAVED_SEARCHES_FETCHED = 'USER_SAVED_SEARCHES_FETCHED';
export function userSavedSearchesFetched(savedSearchesReport) {
  return {
    type: USER_SAVED_SEARCHES_FETCHED,
    isFetchingUserSavedSearches: false,
    userSavedSearchesReport: savedSearchesReport,
  };
}

export const USER_SAVED_SEARCH_REQUEST_STARTED = 'USER_SAVED_SEARCH_REQUEST_STARTED';
export function userSavedSearchRequestStarted() {
  return {
    type: USER_SAVED_SEARCH_REQUEST_STARTED,
    isFetchingUserSavedSearches: true,
  };
}

export const USER_SAVED_SEARCH_DELETED = 'USER_SAVED_SEARCH_DELETED';
export function userSavedSearchDeleted(savedSearch) {
  return {
    type: USER_SAVED_SEARCH_DELETED,
    savedSearch: savedSearch,
  };
}

export const SAVE_SEARCH_DIALOG_OPEN = 'SAVE_SEARCH_DIALOG_OPEN';
export function requestSaveSearchDialogOpen() {
  return {
    type: SAVE_SEARCH_DIALOG_OPEN,
  };
}

export const SAVE_SEARCH_DIALOG_CLOSE = 'SAVE_SEARCH_DIALOG_CLOSE';
export function requestSaveSearchDialogClose() {
  return {
    type: SAVE_SEARCH_DIALOG_CLOSE,
  };
}
